export const COMPASSUS_HH_RPM_BETA_FEATURE = "HH-RPM";

export const isCompassusHhRpmClinic = (
  clinic?: Pick<IClinic, "config"> | null,
  betaFeaturesAllowedList: string[] = []
): boolean => {
  if (!clinic) return false;
  if (!betaFeaturesAllowedList.includes(COMPASSUS_HH_RPM_BETA_FEATURE)) {
    return false;
  }
  return clinic.config?.isHomeHealthRPM === true;
};
